import { useMemo } from "react";
import DataTable from "../_Components/DataTable";
import SplitNumber from "../_Components/SplitNumber";
import _ from "lodash";

import { Button } from "react-bootstrap";
function DataGrid({ data, setShowModalUserPayment, setSelectedUserPayment }) {
  const columns = useMemo(
    () => [
      // {
      //     accessor: "id",
      //     Header: "#",
      //     minWidth: 50,
      // },
      {
        accessor: "orderId",
        Header: "شماره درخواست",
        minWidth: 50,
        align: "center",
      },
      {
        accessor: "userFullName",
        Header: "نام و نام خانوادگی",
        minWidth: "100px",
        align: "center",
      },
      {
        accessor: "phoneNumber",
        Header: " موبایل",
        minWidth: 50,
        align: "center",
      },
      {
        accessor: "basketId",
        Header: "شماره سبد خرید",
        minWidth: "100px",
        align: "center",
      },
      {
        accessor: "rialAmount",
        Header: "مبلغ",
        minWidth: "100px",
        align: "center",
        Footer: ({ data }) => {
          const total = data.reduce((sum, row) => sum + (row.rialAmount || 0), 0);
          return (
            <div className="text-center">
              <SplitNumber number={total} />
            </div>
          );
        },
        Cell: ({ row }) => (
          <div className="text-center">
            <SplitNumber number={row.original.rialAmount} />
          </div>
        ),
      },
      {
        accessor: "userPaymentTypeTitle",
        Header: "درگاه",
        minWidth: "100px",
        align: "center",
      },
      {
        accessor: "cardNumberPayment",
        Header: "شماره کارت واریز کننده",
        minWidth: "130px",
        align: "center",
        // Cell: ({ row }) => (
        //     <div className="text-center">
        //         {(row.original.cardNumberPayment && row.original.cardNumberPayment.length > 4) ? row.original.cardNumberPayment.slice(row.original.cardNumberPayment.length - 4) : row.original.cardNumberPayment}
        //     </div>
        // )
      },
      {
        accessor: "userPaymentStatusS",
        Header: "وضعیت",
        minWidth: "100px",
        align: "center",
        Cell: ({ row }) => (
          <div
            className={`text-center rounded-pill px-4 py-1 d-inline-block ${row.original.userPaymentStatus === 1 ? "text-success bg-light-success" : row.original.userPaymentStatus === 0 ? "text-danger bg-light-danger" : ""}`}
          >
            {row.original.userPaymentStatusS}
          </div>
        ),
      },
      {
        accessor: "createdPersianTime",
        Header: "زمان ایجاد",
        minWidth: "100px",
        align: "center",
      },
      {
        Header: "عملیات",
        accessor: "",
        minWidth: 150,
        align: "center",
        Cell: ({ row }) => (
          <div className="text-center">
            {/* مشاهده  */}
            <Button
              className="btn btn-light-info btn-sm mr-2 btn-icon"
              title="مشاهده اطلاعات"
              onClick={() => {
                setSelectedUserPayment(row.original.id);
                setShowModalUserPayment(true);
              }}
            >
              <i className="far fa-eye text-small"></i>
            </Button>
          </div>
        ),
      },
    ],
    [],
  );

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    show_footer: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };
  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
